<template>
    <ul class="text-base at1200:text-lg">
        <li
            v-for="(resourceGroup, groupType) in resources"
            :key="groupType"
            class="block gap-2 py-4 pl-0 border-b first:border-t"
            @click.prevent="
                    resourceOpen[groupType]
                        ? (resourceOpen[groupType] = false)
                        : (resourceOpen[groupType] = true)
                "
        >
            <button
                class="type-primary hover:text-black flex items-center gap-3 font-medium capitalize group"
            >
                <BaseSvg
                    :name="resourceOpen[groupType] ? 'icon-subtraction-sign' : 'icon-addition-sign-thick'"
                    :class="resourceOpen[groupType] ? 'bg-gray-875' : 'bg-gray'"
                    class="w-4 h-4 fill-white p-0.5 bg-gray rounded-full at1024:group-hover:bg-gray-875"
                />
                {{ groupType }}
            </button>
            <ul v-if="resourceOpen[groupType]" class="p-3">
                <li v-for="(resource, i) in getSortedResources(resourceGroup, groupType)" :key="i">
                    <div class="flex gap-3 py-2 text-base items-center">
                        <span
                            v-if="groupType == 'Key Resources'"
                            class="font-medium text-xs rounded-full px-3 text-white inline-block text-center w-24"
                            :class="keyColors[resource.tags[0].name]"
                        >
                            {{ resource.tags[0].name }}
                        </span>
                        <BaseSvg v-else
                                 :name="getIcon(groupType)"
                                 class="w-6 h-auto shrink-0"
                        />
                        <button
                            @click.stop.prevent="getResource($event, resource)"
                            class="text-left hover:underline underline-offset-4 decoration-1 capitalize at1024:max-w-[370px] at1024:truncate at1200:max-w-[475px] at1350:max-w-[565px] at1440:max-w-[620px] at1550:max-w-[680px]"
                        >
                            <span class="sr-only">Open </span>{{ resource.name }}
                        </button>
                        <button
                            class="group w-6 h-auto"
                            v-if="resource.asset.source === 3"
                            @click.stop="
                                forceDownload(
                                    $event,
                                    marketingAssetUrl(
                                        resource.asset.external_id
                                    ),
                                    _.kebabCase(resource.name) + '.pdf'
                                )
                            "
                        >
                            <BaseSvg
                                class="group-hover:fill-red shrink-0"
                                name="icon-export-file"
                                aria-hidden="true"
                            />
                            <span class="sr-only">Download {{ resource.name }}</span>
                        </button>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script setup>
import { BaseSvg } from "@/Components";
import { useAssetTransforms, useDownload, useResources } from "@/Composables";
import {computed, ref} from "vue";
import _ from "lodash";

const props = defineProps({
    resources: {
        type: Array,
        required: false,
    },
    icons: {
        type: Array,
        required: true,
    },
    getIcon: {
        type: Function,
        required: true,
    },
});

const resourceOpen = ref({});

const sortedResources = computed(() => {
    return props.resources;
})

const getSortedResources = (resources = [], groupType) => {
    return [...resources].sort((a, b) => {
        if (groupType === 'Key Resources') {
            const tagNameA = a.tags?.[0]?.name ?? ''
            const tagNameB = b.tags?.[0]?.name ?? ''
            return tagNameA.localeCompare(tagNameB)
        }

        const nameA = a.asset?.name ?? ''
        const nameB = b.asset?.name ?? ''
        return nameA.localeCompare(nameB)
    })
}

const { getResource } = useResources();
const { marketingAssetUrl } = useAssetTransforms();
const { forceDownload } = useDownload();

const keyColors = {
    'Price Books': 'bg-project-blue',
    'Catalogs': 'bg-project-gray',
    'Parts': 'bg-project-orange',
    'Parts Lists': 'bg-project-orange',
    'Cut Sheets': 'bg-project-avocado',
    'Videos': 'bg-project-lavender',
}
</script>
